<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "index-cost-center"
};
</script>

<style></style>
